<script>
export default {
    name: "DisplayKeywordSearches",
    props: {
        count: {
            required: true,
            default: null
        },
        isFree: {
            default: false
        },
        colorful: {
            default: false
        }
    }
}
</script>

<template>
    <span :class="[colorful ? 'badge badge-info bg-red p5 mt5 pl10 pr10' : '']"  :title="count" v-if="count && count > 0 && !isFree "><strong>{{ $_f.humanNumber(count) }} Searches</strong></span>
    <span :class="[colorful ? 'badge badge-info bg-red p5 mt5 pl10 pr10' : '']" :title="count" onclick="showUpgradeModal()" v-if="isFree"><a class="text-black" href="javascript:void(0);"><strong>N/A Google Searches</strong></a></span>
</template>

